import { canGetOrganizationFileManagerPage } from "@/route-authorization";
export const organization = {
  routes: [
    {
      path: "/organization/file-manager",
      meta: { rules: [canGetOrganizationFileManagerPage] }, // TKP-150
      component: () => import("../file-manager-view"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/gdpr/file-manager",
      component: () => import("../gdpr-file-manager-view"),
    },
  ],
};
export const kvkk = {
  routes: [
    {
      path: "/kvkk/file-manager",
      component: () => import("../kvkk-file-manager-view"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/file-manager",
      component: () => import("../ddo-file-manager-view"),
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/file-manager",
      component: () => import("../bgys-file-manager-view"),
    },
  ],
};
